import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/reference.jpg'


const _hoisted_1 = { class: "grid mb-3 align-items-center" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "grid mb-3 align-items-center" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "grid flex align-items-center mb-3" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col flex align-items-center" }
const _hoisted_8 = { class: "grid flex align-items-center mb-3" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col flex align-items-center" }
const _hoisted_11 = { class: "grid flex align-items-center mb-3" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "_heading-2" }
const _hoisted_14 = { class: "px-4 pb-5" }
const _hoisted_15 = { class: "grid" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "_heading-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_Empty = _resolveComponent("Empty")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_VehicleLicensePlatesBasicDialog = _resolveComponent("VehicleLicensePlatesBasicDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.wrap, "grid justify-content-between"])
    }, [
      _createElementVNode("form", {
        class: _normalizeClass([_ctx.$style.form, "_relative col mt-4"]),
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleSubmit(!_ctx.v$.$invalid)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('settings_page.default_scene')), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["col", _ctx.$style.settingValue])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.bgBox),
              style: _normalizeStyle(`background-image: url(${$setup.previewRoom.preview});`)
            }, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = () => $setup.openModal('bg')),
                type: "button",
                class: _normalizeClass(_ctx.$style.bgAction)
              }, [
                _createVNode(_component_Icon, {
                  name: "edit",
                  className: _ctx.$style.bgBoxIcon
                }, null, 8, ["className"])
              ], 2)
            ], 6)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('settings_page.background_type')), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["col", _ctx.$style.settingValue])
          }, [
            _createVNode(_component_Dropdown, {
              modelValue: $setup.settings.background_type,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.settings.background_type) = $event)),
              options: $setup.optionsBG,
              optionLabel: "label",
              optionValue: "value",
              class: "_full-width",
              disabled: $setup.previewBG.company_id === 1
            }, null, 8, ["modelValue", "options", "disabled"])
          ], 2)
        ])
      ], 34),
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.$style.switches, "col mt-4"])
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('settings_page.cutting')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "inline-flex align-items-center mr-3",
              onClick: _cache[3] || (_cache[3] = () => ($setup.helper = 'cutting'))
            }, [
              _createVNode(_component_Icon, {
                name: "info",
                className: _ctx.$style.info
              }, null, 8, ["className"])
            ]),
            _createVNode(_component_InputSwitch, {
              modelValue: $setup.settings.cutting,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.settings.cutting) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('settings_page.licence_plate_blur')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "inline-flex align-items-center mr-3",
              onClick: _cache[5] || (_cache[5] = () => ($setup.helper = 'blur'))
            }, [
              _createVNode(_component_Icon, {
                name: "info",
                className: _ctx.$style.info
              }, null, 8, ["className"])
            ]),
            _createVNode(_component_InputSwitch, {
              modelValue: $setup.settings.plate_blur,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.settings.plate_blur) = $event)),
              onChange: _cache[7] || (_cache[7] = () => $setup.handlingRelatedSwitches('blur'))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('settings_page.licence_plate_image')), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["col", _ctx.$style.settingValue])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.bgBox),
              style: _normalizeStyle({
              backgroundImage: $setup.settings.licence_plate ? `url(${$setup.settings.licence_plate.url})` : 'none'
            })
            }, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = () => ($setup.isPlateSelectorShown = true)),
                type: "button",
                class: _normalizeClass(_ctx.$style.bgAction)
              }, [
                _createVNode(_component_Icon, {
                  name: "edit",
                  className: _ctx.$style.bgBoxIcon
                }, null, 8, ["className"])
              ], 2)
            ], 6)
          ], 2)
        ])
      ], 2)
    ], 2),
    _createVNode(_component_Button, {
      class: _normalizeClass([_ctx.$style.action, "p-button-big _full-width mt-5"]),
      onClick: $setup.submit
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('save_change')), 1)
      ]),
      _: 1
    }, 8, ["class", "onClick"]),
    _createVNode(_component_Dialog, {
      class: _normalizeClass(_ctx.$style.modal),
      visible: $setup.isShow,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (($setup.isShow) = $event)),
      modal: true,
      draggable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_Toolbar, { class: "p-4" }, {
            left: _withCtx(() => [
              _createElementVNode("p", _hoisted_13, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('available_options')), 1)
              ])
            ]),
            right: _withCtx(() => [
              _createVNode(_component_Button, {
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.isShow = false)),
                class: "p-button-outlined p-button-gray p-button-rounded p-button-only-icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { name: "close" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_14, [
            (!$setup.roomComponentsStoreState.rooms.length)
              ? (_openBlock(), _createBlock(_component_Empty, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.roomComponentsStoreState.rooms, (room) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-3",
                  key: room.id,
                  onClick: () => $setup.setRoom(room)
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(_ctx.$style.modalImgBox)
                  }, [
                    _createElementVNode("img", {
                      src: room.preview,
                      class: _normalizeClass(_ctx.$style.modalImg),
                      alt: ""
                    }, null, 10, _hoisted_17),
                    _createVNode(_component_Icon, {
                      name: "plus",
                      className: _ctx.$style.modalIcon
                    }, null, 8, ["className"])
                  ], 2)
                ], 8, _hoisted_16))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["class", "visible"]),
    _createVNode(_component_Dialog, {
      class: _normalizeClass(_ctx.$style.modal),
      visible: $setup.helper,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (($setup.helper) = $event)),
      modal: true,
      draggable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_Toolbar, { class: "p-4" }, {
            left: _withCtx(() => [
              _createElementVNode("p", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings_page.demo_result')), 1)
              ])
            ]),
            right: _withCtx(() => [
              _createVNode(_component_Button, {
                onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.helper = null)),
                class: "p-button-outlined p-button-gray p-button-rounded p-button-only-icon"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { name: "close" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.helperWrap, "px-4 pb-5 flex"])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.helperBox)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.helperTitle)
              }, _toDisplayString(_ctx.$t('before')), 3),
              _hoisted_19
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.helperBox)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.helperTitle)
              }, _toDisplayString(_ctx.$t('after')), 3),
              _createElementVNode("img", {
                src: $setup.helperImage[$setup.helper],
                alt: ""
              }, null, 8, _hoisted_20)
            ], 2)
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["class", "visible"]),
    _createVNode(_component_VehicleLicensePlatesBasicDialog, {
      isShown: $setup.isPlateSelectorShown,
      onClose: _cache[13] || (_cache[13] = () => ($setup.isPlateSelectorShown = false)),
      onOnPlateSet: $setup.handlePlateSelected
    }, null, 8, ["isShown", "onOnPlateSet"])
  ], 64))
}